/**
 * Created by bartdecorte on 01/06/2017.
 */
import Page from '../Page';
import Request from '../../utils/Request';
import DirtyUnloadNotifier from '../../utils/DirtyUnloadNotifier';

class WebsitesEdit extends Page {
  constructor() {
    super();

    this.mysql = {
      components: {
        dbhost: 'host',
        dbport: 'port',
        dbname: 'database',
        dbuname: 'username',
        dbupass: 'password',
      },
      required: ['dbhost', 'dbname', 'dbuname', 'dbupass'],
    };

    this.fs = {
      components: {
        fs_driver: 'driver',
        uses_pub_key: 'uses_pub_key',
        fs_host: 'host',
        fs_user: 'username',
        fs_password: 'password',
        fs_path: 'path',
      },
      required: ['fs_driver', 'uses_pub_key', 'fs_host', 'fs_user', 'fs_path'],
    };

    this.rp = {
      components: {
        rp_driver: 'driver',
        rp_ssh: 'ssh',
        rp_host: 'host',
        rp_port: 'port',
        rp_secret: 'secret',
        rp_command: 'command',
        fs_driver: 'fs_driver',
        fs_host: 'fs_host',
        fs_user: 'fs_user',
        uses_pub_key: 'uses_pub_key',
      },
      required: [
        'rp_driver',
        'rp_ssh',
        'rp_host',
        'rp_port',
        'rp_secret',
        'rp_command',
        'fs_driver',
        'fs_host',
        'fs_user',
        'uses_pub_key'
      ]
    };

    this.bindListeners();
    new DirtyUnloadNotifier('.js-dirty-unload-notify');
    this.bindKeys(this.keyBindings());
  }

  keyBindings() {
    const bindings = super.keyBindings();
    const scope = this;
    return {
      ...bindings,
      'mod+s': (ev) => scope.lModS(ev),
    };
  }

  lModS(ev) {
    ev.preventDefault();
    this.submitForm();
    return false;
  }

  submitForm() {
    $('.js-website-form .js-btn-save')
      .get(0)
      .click();
  }

  selector(type = 'mysql') {
    return Object.keys(this[type].components)
      .map((c) => {
        return '[name="' + c + '"]';
      })
      .join(', ');
  }

  bindListeners() {
    let $body = $('body');
    $body.on('change', this.selector('mysql'), (ev) => {
      this.lOnComponentChange(ev, 'mysql');
    });
    $body.on('change', this.selector('fs'), (ev) => {
      this.lOnComponentChange(ev, 'fs');
    });
    $body.on('change', this.selector('rp'), (ev) => {
      this.lOnComponentChange(ev, 'rp');
    });
    $(this.selector('mysql'))
      .first()
      .add($(this.selector('fs')).first())
      .trigger('change');
    $body.on('change', '.js-fs-driver', () => this.lOnProtocolChange());
    $body.on('change', '.js-toggle-use-pub-key', () =>
      this.lOnUsePubKeyChange()
    );
  }

  lOnComponentChange(ev, type = 'mysql') {
    let fulfilled = [];

    let selector = this.selector(type);
    let $components = $(selector);
    let fields = {};
    for (let i = 0; i < $components.length; i++) {
      let $component = $($components[i]);
      let name = $component.attr('name');

      if ($component.val()) fields[name] = $component.val();

      if ($component.val() && this[type].required.indexOf(name) > -1)
        fulfilled.push(name);
    }

    if (type == 'fs') {
      fields['uses_pub_key'] = $('[name="uses_pub_key"][value="1"]').is(
        ':checked'
      )
        ? 1
        : 0;
    }

    if (fulfilled.length >= this[type].required.length) {
      let data = {};
      for (let key in this[type].components) {
        if (this[type].components.hasOwnProperty(key)) {
          data[this[type].components[key]] = fields[key];
        }
      }
      data.type = type;

      new Request('connections/test', 'POST', data)
        .execute()
        .then(({ data: { succeeds } }) => {
          this.showSuccessState(type, succeeds);
        });
    } else {
      this.showSuccessState(type);
    }
  }

  lOnProtocolChange() {
    const $elt = $('.js-fs-driver');
    if ($elt.val() !== 'ftp') {
      this.setUsePubKeyVisible(true);
      this.lOnUsePubKeyChange();
    } else {
      this.setUsePubKeyVisible(false);
      this.setPubKeyVisible(false);
      this.setFtpPasswordVisible(true);
    }
    return true;
  }

  lOnUsePubKeyChange() {
    const $elt = $('.js-toggle-use-pub-key');
    if ($elt.is(':checked')) {
      this.setPubKeyVisible(true);
      this.setFtpPasswordVisible(false);
    } else {
      this.setPubKeyVisible(false);
      this.setFtpPasswordVisible(true);
    }
    return true;
  }

  showSuccessState(type = 'mysql', state) {
    let classes = {
      true: 'badge-soft-success',
      false: 'badge-soft-danger',
    };

    let $components = $(this.selector(type));
    $components.filter('.' + classes[!state]).removeClass(classes[!state]);
    $components.not('.' + classes[state]).addClass(classes[state]);

    if (typeof state === typeof undefined)
      $components.filter('.' + classes[false]).removeClass(classes[false]);

    return this;
  }

  setUsePubKeyVisible(visible) {
    const $elt = $('.js-use-pub-key');
    if (visible && $elt.hasClass('d-none')) {
      $elt.removeClass('d-none');
    } else if (!visible && !$elt.hasClass('d-none')) {
      $elt.addClass('d-none');
    }
  }

  setPubKeyVisible(visible) {
    const $elt = $('.js-pub-key');
    if (visible && $elt.hasClass('d-none')) {
      $elt.removeClass('d-none');
    } else if (!visible && !$elt.hasClass('d-none')) {
      $elt.addClass('d-none');
    }
  }

  setFtpPasswordVisible(visible) {
    const $elt = $('.js-fs-password');
    if (visible && $elt.hasClass('d-none')) {
      $elt.removeClass('d-none');
    } else if (!visible && !$elt.hasClass('d-none')) {
      $elt.addClass('d-none');
    }
  }
}

export default WebsitesEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Websites/WebsitesEdit.js